import { ApplicationConfig, importProvidersFrom, inject, Injectable, isDevMode, LOCALE_ID, PLATFORM_ID } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideServiceWorker } from '@angular/service-worker';
import { DatePipe, isPlatformBrowser, registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { routes } from './app.routes';
import { InterceptorFn } from './core/interceptors/interceptor.interceptor';
import { ConfigEnviromentService } from './core/service/configEnviroment.service';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { AuthService } from './core/service/auth.service';
import 'moment/locale/es';

registerLocaleData(localeEs);
Injectable()
export async function setupConfig(config: ConfigEnviromentService) {
  await config.loadConfig();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      })
    ),
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    DatePipe,
    provideHttpClient(withInterceptors([InterceptorFn])),
    provideAnimations(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
    importProvidersFrom(MatMomentDateModule),
    AuthService,
    ConfigEnviromentService,
  ],
};

